//
import { mapActions, mapState } from 'vuex'
import { ModelDataTable, VBtnAction } from '@/components/reusable_components/next'

//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'
import PurchaseOrderService from '@/services/api/Purchase/PchPurchaseOrder'
import filters from './filters'
import headers from './headers'

//
export default {
  name: 'purchase-order-list',
  components: {
    'crud-data-table': ModelDataTable,
    VBtnAction,
  },
  computed: {
    /**
     *
     */
    tableProps() {
      return {
        service: new PurchaseOrderService().toEmittedList(),
        filters,
        headers,
        initialFilterValues: {
          pch_purchase_order_state_id: [4, 5, 6, 7]
        },
        rowsPerPage: 25,
      }
    },
    //
    ...mapState('SnackbarModalModule', {
      responseConfirm: 'responseConfirm',
    }),
  },
  data() {
    return {
      selected: null,
    }
  },
  methods: {

    /**
     * 
     * @param {*} event 
     */
    showError(error) {
      this.showErrorSnackbar(TranslatorService(PurchaseOrderModel, error.response.data))
    },

    /**
     * 
     */
    showSuccessSentToAuthorized() {
      this.showSuccessSnackbar('Orden de compra establecida como autorizada.')
    },

    /**
     *
     */
    submitRectify(event) {
      this.$router.push({
        name: 'purchase-order-rectify',
        params: { id: event.item.id },
      })
    },

    /**
     *
     */
    submitReception(event) {
      this.$router.push({
        name: 'purchase-order-reception',
        params: { id: event.item.id },
      })
    },

    /**
     *
     */
    submitSentToAuthorized(event) {

      //
      this.selected = event.item

      //
      this.showWarningSnackbar({
        title: 'Revertir',
        message: '¿Desea establecer como autorizada la orden?',
        confirm: 'revertir',
      })
    },

    /**
     *
     */
    submitUpdate(event) {
      this.$router.push({
        name: 'purchase-order-update',
        params: { id: event.item.id },
      })
    },

    /**
     * 
     */
    toRefresh() {
      return this
        .$refs
        .table
        .refresh()
    },

    /**
     * 
     */
    toSentToAuthorized() {
      return this
        .selected
        .sentToAuthorized()
        .attach()
        .then(this.showSuccessSentToAuthorized)
        .then(this.toRefresh)
        .catch(this.showError)
    },
  },
  watch: {
    /**
     * 
     */
    responseConfirmSnackbar(val) {
      switch(val) {
        case 'revertir': return this.toSentToAuthorized();
      }
    }
  },
  beforeMount() {
    this.setTitle('Órdenes de compra emitidas')
  },
  beforeRouteEnter(to, from, next) {
    next(ctx => {
      if (!ctx.$can('VIEW_ALL_PURCHASE_ORDER')) ctx.$router.push('/')
    })
  },
}
